// app/avanzamentoCommessa/avanzamentoCommesse.js
(function () {
    'use strict';
    var controllerId = 'avanzamentoCommessa';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$routeParams', '$filter', '$location', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', avanzamentoCommessaFn]);

    function avanzamentoCommessaFn($rootScope, $scope, $routeParams, $filter, $location, common, bDialog, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = $translate.instant('AvanzamentiCommesse');
        vm.sectionMenu = sectionMenu.setSection('Avanzamenti Commesse');                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;        
        vm.exportDisabled = true;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.readonly = false;

        vm.super = $rootScope.isAuthorized('SUPER');
        vm.personale = $rootScope.isAuthorized('PERSONALE');
        vm.capoSezione = $rootScope.isAuthorized('CAPOSEZIONE');
        vm.utente = $rootScope.isAuthorized('USER');
        vm.addDisabled = true;
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Codice', 'Titolo', 'Stato', 'Data aggiornamento'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[3];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        vm.item = {};

        vm.list.attivita = [];
        vm.list.commesseSezioni = [];
        
        //Filtro
        vm.filter = {};
        vm.filter.stato = vm.fStato = -2;
        vm.filter.ricerca = vm.fRicerca = '';
        vm.filter.cliente = vm.fCliente = 0;
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll; 

        //attivita
        vm.getListAttivita = getListAttivita;

        //commesseSezioni
        vm.getListCommesseSezioni = getListCommesseSezioni;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getListClienti()];
            common.activateController(promises, controllerId)
                .then(function () {
                    cerca();
                });
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;
            vm.filter.cliente = vm.fCliente == null ? 0 : vm.fCliente;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.commessa_countAllForTimeSheet(vm.filter.ricerca, vm.filter.cliente, vm.filter.stato).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.commessa_getAllForTimeSheet(vm.pageSize, vm.page, vm.filter.ricerca, vm.filter.cliente, vm.filter.stato, vm.ordine.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);
                }
                vm.loading = false;
            });         
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        //Clienti
        function getListClienti() {
            return datacontext.cliente_getAllList().then(function (data) {
                return vm.list.clienti = data;
            });
        }

        //Attivita
        function getListAttivita(commessa) {
            return datacontext.attivita_getAll(commessa.Id).then(function (data) {
                commessa.showDetail = !commessa.showDetail;
                return commessa.attivita = data;
            });
        }

        //Commesse sezioni
        function getListCommesseSezioni(commessa) {            
            return datacontext.commessaSezione_getAll(commessa.Id, 0).then(function (data) {
                commessa.showDetail = !commessa.showDetail;
                return commessa.sezioni = data;
            });
        }
    }
})();
